'use client';
import { useRouter } from 'next/navigation';
import { PropsWithChildren, useEffect } from 'react';

import { SplashGuard } from '@web/features/SplashScreen/SplashGuard';
import { isUserCompleted, useCurrentUser } from '@web/features/user/service';

export default ({ children }: PropsWithChildren) => {
  const router = useRouter();
  const currentUser = useCurrentUser();
  useEffect(() => {
    if (currentUser.status === 'pending') return;
    if (!isUserCompleted(currentUser)) {
      return router.replace('/');
    }
  }, [currentUser]);

  return (
    <SplashGuard guardIf={!isUserCompleted(currentUser)}>
      {children}
    </SplashGuard>
  );
};
